import { render, staticRenderFns } from "./SaveIndicator.vue?vue&type=template&id=08d7e014&scoped=true"
import script from "./SaveIndicator.vue?vue&type=script&lang=ts"
export * from "./SaveIndicator.vue?vue&type=script&lang=ts"
import style0 from "./SaveIndicator.vue?vue&type=style&index=0&id=08d7e014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7e014",
  null
  
)

export default component.exports